<template>
	<!-- 已废弃 已废弃 已废弃 已 废弃 已废弃 已废弃 已废弃已废弃已废弃 已废弃已废弃已废弃已废弃 已废弃已废弃已废弃已废弃已废弃已废弃已废弃已废弃 -->
	<div class="comp">
		<el-dialog :title="'支付前批量更换'" :visible.sync="dialogState" width="1000px" top="3vh">
			<el-row>
				<el-col style="font-size: 18px;">更换前：</el-col>
			</el-row>
			<div style="max-height:500px;overflow-y: scroll;margin-left:30px;margin-top:10px;" v-if="list.length>0">
				<div v-for="(item,index) in list" :key="index">
					<div class="label">{{detail.plans[index].planName}}</div>
					<el-table class="table" :data="item" :ref="'plan'+index" style="width: 100%" @selection-change="handleSelectionChange(arguments[0],index)">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="goodsName" label="名称" >
						</el-table-column>
						<el-table-column prop="skuValue" label="规格" width="220">
						</el-table-column>
						<el-table-column prop="num" label="数量" width="80">
						</el-table-column>
						<el-table-column prop="price" label="单价" width="100">
						</el-table-column>
						<el-table-column prop="unit" label="小计" width="120">
							<template slot-scope="props">
								{{$public.getSubtotal(props.row)}}
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<el-row>
				<el-col style="font-size: 18px;padding-top:30px;">更换后：</el-col>
			</el-row>
			<el-table class="table" :data="newGoodsList" style="width: 100%;padding-left:30px;">
				<el-table-column prop="goodsName" label="名称" >
				</el-table-column>
				<el-table-column prop="skuValue" label="规格" width="220">
				</el-table-column>
				<el-table-column prop="num" label="数量" width="80">
				</el-table-column>
				<el-table-column prop="price" label="单价" width="100">
				</el-table-column>
				<el-table-column prop="unit" label="小计" width="120">
					<template slot-scope="props">
						{{$public.getSubtotal(props.row)}}
					</template>
				</el-table-column>
				<el-table-column prop="unit" label="操作" width="120">
					<template slot-scope="props">
						<el-button type="danger" @click="del(props.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" style="text-align: center;margin-top:20px;padding-bottom:30px;">
				<el-button type="success" @click="addGoods" v-if="newGoodsList.length===0">添加更换商品</el-button>
				<el-button type="primary" @click="submit">确定更换</el-button>
			</div>
		</el-dialog>
		<div v-if="dialogAddGoods_state">
			<dialogAddShop :addShopState="dialogAddGoods_state" :shopId="curShopId" :tree="[{id:'602f1e88c904d9db7ccf3bec',children:[{id:'602f1e88c904d9db7ccf3bed'},{id:'602f1e89c904d9db7ccf3bf6'},{id:'602f1e89c904d9db7ccf3bf8'},{id:'602f1e89c904d9db7ccf3bfc'},{id:'602f1e89c904d9db7ccf3bff'}]}]" @submit="submit_dialogAddGoods"></dialogAddShop>
		</div>
	</div>
</template>
<script>
	import dialogAddShop from "../../../../components/dialog_addShop.vue"
	export default {
		components:{dialogAddShop},
		data() {
			return {
				dialogState:true,
				detail:{},
				list:[],
				selectionList:[],
				// 添加商品
				dialogAddGoods_state:false,
				newGoodsList:[],
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		props:{
			ymqcDetail:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(n){
				this.$emit('submit',n)
			}
		},
		mounted() {
			this.detail = JSON.parse(JSON.stringify(this.ymqcDetail))
			for(let i=0;i<this.detail.plans.length;i++){
				let list = []
				for(let a=0;a<this.detail.plans[i].planGoods.length;a++){
					if(this.detail.plans[i].planGoods[a].goodsType===1){
						list.push(this.detail.plans[i].planGoods[a])
					}
				}
				this.list.push(list)
			}
			this.$nextTick(()=>{
				for(let i=0;i<this.list.length;i++){
					for(let a=0;a<this.list[i].length;a++){
						this.$refs['plan'+i][0].toggleRowSelection(this.list[i][a],true)
					}
				}
			})
		},
		methods: {
			handleSelectionChange(selection,type){
				this['plan'+type]=selection;
				this.selectionList[type] = selection;
			},
			// 添加
			addGoods(){
				this.dialogAddGoods_state = true;
			},
			// 删除
			del(index){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.newGoodsList.splice(index,1)
				})
			},
			selectGoods({goodsItem,skuItem,wayItem,goodsType}){
				let row = this.$public.getRow(goodsItem,skuItem,wayItem,goodsType)
				if(this.newGoodsList.length>0){
					this.$message({
						message: '只能添加一个商品',
						type: 'error'
					});
					return ;
				}
				let table = this.newGoodsList;
				for(let i=0;i<table.length;i++){
					if(table[i].skus==row.skus&&table[i].goodsId==row.goodsId){
						this.$message({
							message: '该商品已添加',
							type: 'error'
						});
						return ;
					}
				}
				if(row.stock==0){
					this.$message({
						message: '该商品已没有库存，请及时申请采购',
						type: 'error'
					});
					return ;
				}
				// row.originalPrice = this.$public.cheng(row.originalPrice,0.88)
				// row.price = this.$public.cheng(row.price,0.88)
				table.push(row)
				this.$message({
					message: '添加成功',
					type: 'success'
				});
			},
			submit(){
				let num = 0;
				for(let i=0;i<this.selectionList.length;i++){
					num = num + this.selectionList[i].length;
				}
				if(num===0){
					this.$message({
						message: '请选择商品',
						type: 'error'
					});
					return ;
				}
				if(this.newGoodsList.length===0){
					this.$message({
						message: '请添加商品',
						type: 'error'
					});
					return ;
				}
				let replaceItemsIdsList = []
				for(let i=0;i<this.selectionList.length;i++){
					for(let a=0;a<this.selectionList[i].length;a++){
						let id = this.selectionList[i][a].itemsId;
						replaceItemsIdsList.push(id)
					}
				}
				let addGoodsList = []
				for(let i=0;i<this.newGoodsList.length;i++){
					let goods = this.newGoodsList[i];
					let item = {
						"brand": goods.brand,
						"categoryId": goods.categoryId,
						"categoryName":goods.categoryName,
						"allowWholesale": goods.allow_wholesale,
						"dosageCeiling": goods.dosageCeiling,
						"dosageCeilingValue": goods.dosageCeilingValue,
						"goodsId": goods.goodsId,
						"goodsName": goods.goodsName,
						"goodsType": 1,
						"skus": goods.skus,
						"skuValue": goods.skuValue,
						"model": goods.model,
						"unit": goods.unit,
						"outUnit": goods.outUnit,
						"originalPrice": goods.originalPrice,
						"price": goods.price,
						"num": goods.num,
						"activityId": '',
						"activityName": '',
						"totalMoney": goods.totalMoney,
						"goodsUsage": goods.goodsUsage,
						"goodsDosage": goods.goodsDosage,
						"goodsTimes": '',
						"remark": goods.remark,
						"extendContent": goods.extendContent,
						"canActivity": true,
					}
					addGoodsList.push(item)
				}
				let params = {
					"servicerId": this.ymqcDetail.id,
					"replaceItemsIds": replaceItemsIdsList,
					"replaceGoods": addGoodsList[0]
				}
				console.log(params)
				this.$http.post('/api/MedicalPackage/ReplaceGoodsMany', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit('submit')
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.label{
			font-size: 14px;font-weight: bold;padding:20px 0 1px;
		}
		::v-deep.el-dialog__body{
			padding-top:10px;
		}
	}
</style>
